<template>
  <div class="viewContent">
    <!-- <l-dialog
      :show="isInfo"
      :isbtn="false"
      :ischa="true"
      @cancel="isInfo=false"
      class="msgDialog"
      :title="teamName"
    >
      <div class="left">
        <p class="tit">测试结果</p>
        <div ref="bar" id="bar" style="height:3rem;width:6.2rem"></div>

        <p class="msg" v-html="resultMsg"></p>

      </div>
      <div class="right">
        <p class="tit">—— 团体测评 ——</p>
        <p>
          发布人：
          <span>{{scaleInfo.publisherName}}</span>
        </p>
        <p>
          测评人数：
          <span>{{scaleInfo.planTotalPeople}}</span>
        </p>
        <div class="btn">
          <l-button value="删除" color="#3170FF" @click.native="operate(4)"></l-button>
          <l-button value="导出" color="#FF500C" @click.native="exportWord()"></l-button>
          <l-button value="关闭" @click.native="isInfo=false"></l-button>
        </div>
      </div>
    </l-dialog> -->
    
    <div class="search">
      <p>您可以在这里管理所有的量表：</p>
      <div>
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="search">
          <template slot="append"><span @click="getResult()">搜索</span></template>
        </el-input>
      </div>
    </div>
    <div class="table">
      <div class="type">共有量表测评结果：{{queryObj.total}}份</div>
      <table style="padding:0 .35rem">
        <tr>
          <th style="width:3.55rem" @click="selectBox.scaleTh = !selectBox.scaleTh">
            团体任务名称
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="select selectScale" :show.sync="selectBox.scaleTh">
              <p :class="{'on':queryObj.title == 'asc'}" @click="getResult({title:'asc',})">按拼音（正序）</p>
              <p :class="{'on':queryObj.title == 'desc'}" @click="getResult({title:'desc',})">按拼音（倒序）</p>
            </eject-select-list>
          </th>
          <th style="width:1.8rem" @click="selectBox.nameTh = !selectBox.nameTh">
            用户姓名
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="select" :show.sync="selectBox.nameTh">
              <p :class="{'on':queryObj.name == 'asc'}" @click="getResultList({name:'asc',time:'',sort:'',uid:'',})">按拼音（正序）</p>
              <p :class="{'on':queryObj.name == 'desc'}" @click="getResultList({name:'desc',time:'',sort:'',uid:'',})">按拼音（倒序）</p>
            </eject-select-list>
          </th>
          <th style="width:.8rem" @click="selectBox.idTh = !selectBox.idTh">
            序号
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="select" :show.sync="selectBox.idTh">
              <p :class="{'on':queryObj.uid == 'asc'}" @click="getResultList({name:'',time:'',sort:'',uid:'asc',})">正序</p>
              <p :class="{'on':queryObj.uid == 'desc'}" @click="getResultList({name:'',time:'',sort:'',uid:'desc',})">倒序</p>
            </eject-select-list>
          </th>
          <th style="width:2rem">注册账号</th>
          <th style="width:.8rem" @click="selectBox.sexTh = !selectBox.sexTh">
            性别
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="select" :show.sync="selectBox.sexTh">
              <p :class="{'on':queryObj.sex == ''}" @click="getResultList({sex:'',page: 1})">全部</p>
              <p :class="{'on':queryObj.sex == '男'}" @click="getResultList({sex:'男',page: 1})">男</p>
              <p :class="{'on':queryObj.sex == '女'}" @click="getResultList({sex:'女',page: 1})">女</p>
            </eject-select-list>
          </th>
          <th style="width:1.8rem" @click="selectBox.classTh = !selectBox.classTh,getClass()">
            所在部门
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="select" :show.sync="selectBox.classTh">
              <p :class="{'on':queryObj.catId == ''}" @click="getResultList({catId:'',page: 1})">全部</p>
              <p
                v-for="(item,index) in classList"
                :key="index"
                :class="{'on':queryObj.catId == item.deptid}"
                @click="getResultList({catId:item.deptid,page: 1})"
              >{{item.deptname}}</p>
            </eject-select-list>
          </th>
          <th style="width:1.8rem" @click="selectBox.timeTh = !selectBox.timeTh">
            完成日期
            <i class="el-icon-caret-bottom"></i>
            <eject-select-list class="select selectTime" :show.sync="selectBox.timeTh">
              <l-date-picker v-model="queryObj.date" @change="getResultList({page:1})"></l-date-picker>
              <!--<p @click="selectBox.isDate=!selectBox.isDate">选择日期范围</p>
              <div v-show="selectBox.isDate" style="margin-top:.05rem">
                <div>
                  <el-input v-model="queryObj.startDate" style="width:.9rem"></el-input>
                  <span style="margin:0 5px">-</span>
                  <el-input v-model="queryObj.endDate" style="width:.9rem"></el-input>
                  <i
                    class="el-icon-search"
                    style="font-size:.18rem;margin-left:.05rem"
                    @click="getResultList({page: 1}),selectBox.timeTh=false"
                  ></i>
                </div>
                <Calendar
                  @choseDay="clickDay"
                  @changeMonth="changeDate"
                  :markDate="markDate"
                  ref="cale"
                />
              </div>-->
              <p :class="{'on':queryObj.time == 'asc'}" @click="getResultList({name:'',time:'asc',sort:'',uid:'',})">按最远建立排序</p>
              <p :class="{'on':queryObj.time == 'desc'}" @click="getResultList({name:'',time:'desc',sort:'',uid:'',})">按最近建立排序</p>
            </eject-select-list>
          </th>
          <th style="width:1.3rem">操作</th>
        </tr>
      </table>

      <div class="grid">
        <div class="left">
          <ul>
            <li
              v-for="(item,index) in resultList"
              :key="index"
              :class="scaleId==index ? 'activeScale' : ''"
              @click="getResultList({id:item.publishInfoId,page: 1}),scaleId=index"
            >
              <div class="msg">
                <img src="@/assets/img/home/tt.png" alt />
                <span>{{item.title}}</span>
              </div>
              <p class="status">(进度：{{item.finishTotal}}/{{item.total}}) 可查看结果</p>
            </li>
          </ul>
        </div>
        <div>
          <table>
            <tr v-for="(item,index) in userList" :key="index">
              <td style="width:1.8rem">
                <div class="td1">
                  <!-- <div class="bad" v-show="item.isRead==0"></div> -->
                  <img :src="global.ip+item.avatar" />
                  {{item.nickname}}
                </div>
              </td>
              <td style="width:.8rem">{{item.id}}</td>
              <td style="width:2rem">{{item.username}}</td>
              <td style="width:.8rem">{{item.sex}}</td>
              <td style="width:1.8rem">{{item.deptname}}</td>
              <td style="width:1.8rem">{{formatDate(item.testTime)}}</td>
            </tr>
          </table>
        </div>
        <div class="right">
          <l-button value="查看" color="#3170FF" @click.native="handLook()"></l-button>
          <!-- <l-button value="设为可查看" color="#3170FF" @click.native="operate(2)"></l-button>
          <l-button value="设为不可查看" color="#3170FF" @click.native="operate(3)"></l-button>-->
          <!-- <l-button value="导出" color="#FF500C" @click.native="handLook()"></l-button> -->
          <l-button value="删除" color="#F0F0F0" style="color:#333333" @click.native="operate(4)"></l-button>
        </div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="queryObj.total"
      :currentPage="queryObj.page"
      :page-size="queryObj.pageSize"
      @current-change="changePage"
    ></el-pagination>

    <team-SCL90
      :show.sync="isInfo"
      :publishInfoId="team_publishInfoId"
      @deleteF="operate(4)"
    ></team-SCL90>
    <team-MHT
      :show.sync="teamMHT_show"
      :publishInfoId="team_publishInfoId"
      @deleteF="operate(4)"
    ></team-MHT>
    <team-MHRSP
      :show.sync="teamMHRSP_show"
      :publishInfoId="team_publishInfoId"
      @deleteF="operate(4)"
    ></team-MHRSP>

  </div>
</template>

<script>
require("../../../utils/export/jquery.wordexport");
import lButton from "@/components/lButton.vue";
import lDialog from "@/components/lDialog.vue";
import Calendar from "vue-calendar-component";
import teamMHT from "./template/teamMHT.vue";
import teamMHRSP from "./template/teamMHRSP.vue";
import teamSCL90 from "./template/teamSCL90.vue";
import { formatDate1 } from "../../../assets/js/formatDate";
import { formatDate2 } from "@/utils/common/formatDate.js";
let bar = "";
export default {
  data() {
    return {
      uid: JSON.parse(localStorage.getItem("userinfo")).uid,
      resultList: [],
      scaleInfo: {},
      userList: [],
      scaleTh: false,
      personTh: false,
      search: "",
      scaleId: 0,
      //详情
      teamName: "",
      teamMHT_show: false,
      teamMHRSP_show: false,
      team_publishInfoId: '',
      isInfo: false,
      info: {},
      recordResult: {},
      resultMsg: "",
      record: [],

      markDate: [],
      queryObj: {
        id: '',

        title: '',
        name: '',
        uid: '',
        sex: '',
        catId: '',
        startDate: '',
        endDate: '',
        date: [],
        time: '',

        page: 1,
        pageSize: 10,
        total: 0,
      },
      selectBox: {
        scaleTh: false,
        nameTh: false,
        idTh: false,
        sexTh: false,
        classTh: false,
        timeTh: false,
        isDate: false,
      },
      classList: [],
    };
  },
  methods: {
    //echarts
    handEcharts() {
      //销毁echarts实例
      if (bar) {
        bar.dispose();
      }
      bar = this.echarts.init(this.$refs.bar);
      let colors = ['#0AA7F4','#ED6942','#F29EC2','#36D5E5','#12B5B0','#F9B552','#e91e63','#f44336','#EEAD0E','#E066FF','#B3EE3A'];
      let option = {
        grid: {
          top: "30",
          left: "40",
          right: "50",
          bottom: "60",
        },
        backgroundColor: "#fff",
        xAxis: {
          type: "category",
          //data: Array.from({ length: this.record.length }, (x, i) => x + i),
          axisLine: {
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 7], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: true, //---是否显示
            inside: true, //---是否朝内
            lengt: 2, //---长度
            lineStyle: {
              //color:'red',			//---默认取轴线的颜色
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 30,
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 10], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: false, //---是否显示
          },
          splitLine: {
            //---grid 区域中的分隔线
            show: true, //---是否显示，'category'类目轴不显示，此时我的X轴为类目轴，splitLine属性是无意义的
            lineStyle: {
              color: "#404040",
              opacity: "0.2",
              width: 1,
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              //---图形形状
              borderRadius: [5, 5, 0, 0],
              color: function (params) {
                return colors[params.dataIndex % colors.length];
              },
            },
            barWidth: 20, //---柱形宽度
            // barCategoryGap: "20%", //---柱形间距
            data: this.record,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      bar.setOption(option);
      window.addEventListener("resize", function () {
        bar.resize();
      });
    },
    //导出
    exportWord() {
      let _this = this;
      let baseArr = [];
      let pre = "";
      var urlData = $("#bar").find("canvas")[0].toDataURL("image/jpeg");
      baseArr.push({
        // data: urlData.substring(urlData.indexOf(":") + 1, urlData.indexOf(";")),
        encoding: urlData.substring(
          urlData.indexOf(";") + 1,
          urlData.indexOf(",")
        ),
        location: urlData,
        data: urlData.substring(urlData.indexOf(",") + 1),
      });
      pre = `<p>${this.resultMsg}</p>`;
      let html = `<div>
                <h2 style="text-align:center">《${this.scaleInfo.title}》</h2>
                <div style="display:flex">
                    <span>发布人：${this.scaleInfo.publisherName}</span>&nbsp;&nbsp; <span>测评人数：${this.scaleInfo.testTotalPeople}</span><br>
                    <h4>测试结果</h4>
                    <img src="${urlData}">
                    ${pre}
                </div></div>`;
      setTimeout(function () {
        $(html).wordExport(_this.scaleInfo.title, baseArr);
      }, 1000);
    },
    //获取部门
    async getClass() {
      let { data } = await this.$post("api/msg/dept");
      this.classList = data.data.list;
    },
    //获取结果列表
    async getResult(qObj = this.queryObj) {
      qObj = Object.assign(this.queryObj, qObj)
      let { data } = await this.$post("api/test/getPublishInfoList", {
        title: this.search,
        title_desc: qObj.title,
        testType: 2,
        curPage: 1,
        pageSize: 10000,
      });
      this.checkAll = false;
      this.checkLists = [];
      this.resultList = data.data.list;
      this.getResultList({id: this.resultList[this.scaleId].publishInfoId});
    },
    //获取普查用户
    async getResultList(qObj = this.queryObj) {
      qObj = Object.assign(this.queryObj, qObj)
      let user = await this.$post("api/test/getTableResultList", {
        testType: 2,
        publishInfoId: qObj.id,
        name_desc: qObj.name,
        id_desc: qObj.uid,
        sex: qObj.sex,
        starttime: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
        endtime: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
        catId: qObj.catId,
        time_desc: qObj.time,
        curPage: qObj.page,
        pageSize: qObj.pageSize,
      });
      this.userList = user.data.data.list;
      this.queryObj.total = user.data.data.total;
    },
    //查看
    async handLook() {
      console.log(this.resultList[this.scaleId])
      if (this.resultList[this.scaleId].finishTotal < 1) {
        this.$myMessage("目前该团体测评未出结果，无法查看");
        return
      }
      let gaugeTitle = this.resultList[this.scaleId].gaugeTitle
      if (/MHT/.test(gaugeTitle)) { // 中小学生心理健康诊断测验(MHT)
        this.teamMHT_show = true;
        this.team_publishInfoId = this.resultList[this.scaleId].publishInfoId;
      } else if (/MHRSP/.test(gaugeTitle)) { // 小学生心理健康评定量表（MHRSP）
        this.teamMHRSP_show = true;
        this.team_publishInfoId = this.resultList[this.scaleId].publishInfoId;
      } else if (/SCL-90/.test(gaugeTitle)) { // 症状自评量表(SCL-90)
        this.isInfo = true;
        this.team_publishInfoId = this.resultList[this.scaleId].publishInfoId;
        // let { data } = await this.$post("api/test/getTeamResultByInfoId", {
        //   publishInfoId: this.resultList[this.scaleId].publishInfoId,
        // });
        // console.log(data);
        // this.isInfo = true;
        // this.info = data.data.list;
        // this.scaleInfo = data.data.Info;
        // this.teamName = this.scaleInfo.title;
        // this.resultMsg = this.info[0].result;
        // this.recordResult = {};
        // this.record = this.info[0].rangeList.map((item) => {
        //   return [item.range, item.totalPeople];
        // });
        // this.handEcharts();
      } else {
        this.$myMessage("无效的团体量表");
      }
    },
    //删除
    operate(type) {

      let foo = ()=>{
        this.$post("api/test/tableResultOperate", {
          testType: 2,
          type: type,
          publishInfoId: this.resultList[this.scaleId].publishInfoId,
        }).then(()=>{
          this.isInfo = false;
          this.teamMHT_show = false;
          this.teamMHRSP_show = false;
          this.scaleId = 0;
          this.getResult();
        })
      }

      if (type == 4) {
        this.$popup({
          title: '提示',
          content: '是否要删除勾选的记录？',
          saveFoo: () => {
            foo()
          },
        })
      } else {
        foo()
      }

    },
    //分页
    changePage(page) {
      this.queryObj.page = page;
      // this.getResult();
      this.getResultList();
    },
    //日期格式转换
    formatDate(time) {
      if (!isNaN(+time)) {
        return formatDate1(time);
      }
      return time
    },

    //选择日期
    clickDay(val) {
      if (this.markDate.length < 2) {
        this.markDate.push(val);
      } else {
        if (new Date(val) > new Date(this.markDate[1])) {
          this.$set(this.markDate, 1, val);
        } else if (new Date(val) < new Date(this.markDate[0])) {
          this.$set(this.markDate, 0, val);
        } else {
          this.$set(this.markDate, 0, val);
          this.$set(this.markDate, 1, val);
        }
      }
      this.queryObj.startDate = this.markDate[0];
      this.queryObj.endDate = this.markDate[1];
    },
    changeDate(val) {
      console.log(val);
    },
  },
  mounted() {
    this.getClass()
    this.getResult();
    //this.handEcharts();
  },
  components: {
    "l-button": lButton,
    "l-dialog": lDialog,
    "team-MHT": teamMHT,
    "team-MHRSP": teamMHRSP,
    'team-SCL90': teamSCL90,
    Calendar,
  },
};
</script>

<style lang='less' scoped>
.viewContent {
  //弹出框
  /deep/.msgDialog .dialog {
    width: 1000px;
    height: 750px;
    .content {
      display: flex;
    }
    .left {
      width: 719px;
      overflow-y: auto;
      border-right: 1px solid #f0f0f0;
      padding-left: 59px;
      box-sizing: border-box;
      .tit {
        color: #404040;
        padding-top: 39px;
      }
      .tag {
        color: #404040;
        margin-bottom: 25px;
      }
      .msg {
        word-break: break-all;
        text-align: justify;
        font-size: 14px;
        color: #555555;
        line-height: 30px;
      }
    }
    .right {
      font-size: 14px;
      width: 280px;
      box-sizing: border-box;
      .tit {
        margin: 39px 0 29px 0;
        text-align: center;
        color: #5f5f5f;
      }
      p {
        margin-left: 30px;
        margin-bottom: 25px;
      }
      span {
        color: #555;
      }
      .btn {
        position: absolute;
        height: 40px;
        width: 240px;
        text-align: center;
        line-height: 40px;
        bottom: 50px;
        right: 20px;
        button {
          width: 70px;
          margin: 0 5px;
        }
      }
    }
  }
  /deep/.delLog {
    width: 350px;
    height: 240px;
    p {
      padding: 49px 0 24px 0;
      color: #333333;
      text-align: center;
    }
  }

  .table {
    margin-top: 20px;
    height: 770px;
    width: 1430px;
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
    .type {
      height: 60px;
      line-height: 60px;
      color: #222222;
      background: #f0f0f0;
      text-align: center;
    }
    .grid {
      display: flex;
      padding: 0 35px;
      .left {
        width: 320px;
        height: 570px;
        box-sizing: border-box;
        border-right: 1px solid #f0f0f0;
        overflow: auto;
        li {
          height: 90px;
          border-bottom: 1px solid #f0f0f0;
          padding-top: 5px;
          padding-left: 30px;
          box-sizing: border-box;
        }
        .activeScale {
          background: #e0f0ff;
        }
        .msg {
          display: flex;
          align-items: center;
          // margin-bottom: 18px;
          height: 50px;
          img {
            width: 40px;
            height: 20px;
            margin-right: 20px;
          }
          span {
            color: #222222;
            font-size: 14px;
          }
        }
        .status {
          font-size: 14px;
          color: #999999;
        }
      }
      table {
        width: 900px;
        border-collapse: collapse;
      }
      .right {
        width: 140px;
        height: 570px;
        box-sizing: border-box;
        border-left: 1px solid #f0f0f0;
        padding-left: 28px;
        button {
          height: 40px;
          line-height: 40px;
          width: 110px;
          font-size: 14px;
          border-radius: 6px;
          margin-top: 16px;
        }
      }
    }
    table {
      font-size: 14px;
      border-collapse: collapse;
      tr {
        height: 57px;
        text-align: center;
      }
      th {
        color: #555;
        font-weight: 400;
        position: relative;
        .el-checkbox {
          margin-right: 5px;
        }
      }
      td {
        .el-checkbox {
          margin: 0 20px 0 5px;
        }
      }
      .td1 {
        display: flex;
        align-items: center;
        position: relative;
        .bad {
          position: absolute;
          left: 72px;
          top: 0px;
          height: 10px;
          width: 10px;
          background-color: red;
          border-radius: 50%;
        }
        img {
          margin-left: 20px;
          height: 36px;
          width: 36px;
          margin-right: 18px;
          border-radius: 50%;
          border: 2px solid #3170ff;
        }
      }
      .td4 {
        display: flex;
        align-items: center;
        height: 57px;
        box-sizing: border-box;
        img {
          margin: 0 20px 0 30px;
        }
      }
      th,
      td {
        border-bottom: 1px solid #f0f0f0;
      }
      button {
        height: 40px;
        width: 80px;
        border-radius: 6px;
        border: 0;
        font-size: 14px;
      }
      .edit {
        margin-right: 15px;
        background: #3170ff;
        color: #fff;
      }
      .del {
        background: #f0f0f0;
        color: #333333;
      }
    }
  }
  .el-pagination {
    bottom: 70px;
  }
}
</style>